// extracted by mini-css-extract-plugin
module.exports = {"ow4rckf":"ow4rckf"};